export default {
  login: "ログイン",
  logout: "ログアウト",
  loggingIn: "ログインしています…",
  selectIdp: "ログイン方法を選択してください",
  forbidden: {
    title: "この操作を行う権限がありません",
    description: "権限が必要な場合は管理者にお問い合わせください。",
  },
  userMenu: {
    account: "アカウント",
    groups: "所属グループ",
  },
  theme: {
    label: "テーマ",
    light: "ライト",
    dark: "ダーク",
    system: "システム設定に合わせる",
  },
  language: {
    label: "言語",
    ja: "日本語",
    en: "English",
  },
} as const;
